import * as actions from "./actionTypes";

const initialData = {
  loaderPlantillaCompetencia: false,
  plantillaCompetencia: {data:[], count: 0},
  plantillaCompetenciaFalla: null,
  saveLoaderPlantillaCompetencia: false,
  plantillaCompetenciaFormError:null,
  plantillaCompetenciaFormCopyError:null
};

export default function PlantillaCompetenciaReducer(state = initialData, action) {
  switch (action.type) {
    case actions.LOADER_PLANTILLA_COMPETENCIA:
      return { ...state, loaderPlantillaCompetencia: action.payload };

    case actions.GET_PLANTILLA_COMPETENCIA:
      return { ...state, plantillaCompetencia: action.payload };

    case actions.PLANTILLA_COMPETENCIA_FALLA:
      return { ...state, plantillaCompetenciaFalla: action.payload };

    case actions.SAVE_LOADER_PLANTILLA_COMPETENCIA:
      return { ...state, saveLoaderPlantillaCompetencia: action.payload };

    case actions.FORM_PLANTILLA_COMPETENCIA_FAIL:
      return { ...state, plantillaCompetenciaFormError: action.payload };

    case actions.FORM_COPY_PLANTILLA_COMPETENCIA_FAIL:
      return { ...state, plantillaCompetenciaFormCopyError: action.payload };

    default:
      return state;
  }
}
